<template>
  <generic-trash
    v-model="selected"
    :getPag="getPagAux"
    :getExcel="getExcelAux"
    :getParams="getParamsAux"
    :doRestore="doRestoreAux"
    :doDelete="doDeleteAux"
    :FilterPanel="FilterPanel"
    :RouteName="RouteName"
    :dialogTitle="dialogTitle"
    :dialogMesage="dialogMesage"
    :ExcelName="ExcelName"
    :idVista="idVista"
    :HeaderTitle="HeaderTitle"
    :vuexnamespace="vuexnamespace"
    :PayloadSingleId="PayloadSingleId"
    :PayloadMultipleId="PayloadMultipleId"
  />
</template>

<script>
import { i18n } from '@/i18n'
import GenericTrash from '@/views/trash/GenericTrash.vue'
import CustomFilter from '@/components/filters/trash/UsersFilter.vue'
import { getUsers } from '@/services/configurations/getUsers'
import { downloadUsersUexcel } from '@/services/configurations/downloadUsersUexcel'
import { deleteTrashUser } from '@/services/trash/deleteTrashUser'
import { restoreTrashUser } from '@/services/trash/restoreTrashUser'

export default {
  name: 'vista-papelera-usuarios',
  components: {
    GenericTrash,
  },
  data: function () {
    return {
      FilterPanel: CustomFilter,
      RouteName: 'users',
      dialogTitle: i18n.t('users.delete_user'),
      dialogMesage: i18n.t('app.delete_permanent_selected_confirmation', { entity: i18n.t('users.header').toLowerCase() }),
      ExcelName: 'usuarios-borrados.xlsx',
      idVista: 23,
      HeaderTitle: i18n.t('trash.users'),
      vuexnamespace: 'trashUsers',
      BreadcrumbName: 'Usuario',
      PayloadSingleId: 'idUsuario',
      PayloadMultipleId: 'idsUsuario',
      selected: []
    }
  },
  methods: {
    getParamsAux (data) {
      return {
        nombre: data.name ? data.name.value : null,
        email: data.email ? data.email.value : null,
        nombreGrupo: data.nombreGrupo ? data.nombreGrupo.value : null,
        idDistribuidor: data.distribuidor ? data.distribuidor.value?.idDistribuidor : null,
        idCliente: data.empresa ? data.empresa.value?.idCliente : null,
        rol: data.role ? data.role.value : null,
        langCode: data.idioma ? data.idioma.value : null,
        tipoAutenticacion: data.tipoAuth ? data.tipoAuth.value : null,
        VerTodoEstados: data.verTodoStatuses ? data.verTodoStatuses.value : null,
        VerTodoEmpresas: data.verTodoCompanies ? data.verTodoCompanies.value : null,
        Activo: data.activo ? data.activo.value : null,
      }
    },
    getPagAux: async function (objOrder, params) {
      return await getUsers(objOrder, params)
    },
    getExcelAux: async function (objOrder, params) {
      return await downloadUsersUexcel(objOrder, params)
    },
    doRestoreAux: async function (payload) {
      return await restoreTrashUser(payload)
    },
    doDeleteAux: async function (payload) {
      return await deleteTrashUser(payload)
    },
  }
}
</script>
